import React from 'react';
import { Layout, Check } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';

const pageLayouts = [
  {
    id: 'default',
    name: 'Standard Layout',
    description: 'Kategorien links, Inhalte rechts',
    preview: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAwIiBoZWlnaHQ9IjMwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iNDAwIiBoZWlnaHQ9IjMwMCIgZmlsbD0iI0U4RTBENSIvPjxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIyODAiIGZpbGw9IiNDNEEwODQiIG9wYWNpdHk9IjAuMyIvPjxyZWN0IHg9IjEyMCIgeT0iMTAiIHdpZHRoPSIyNzAiIGhlaWdodD0iMjgwIiBmaWxsPSIjQzRBMDg0IiBvcGFjaXR5PSIwLjIiLz48dGV4dCB4PSIyMDAiIHk9IjE1MCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZm9udC1mYW1pbHk9IkFyaWFsIiBmb250LXNpemU9IjE4IiBmaWxsPSIjNkQ1QTQ3Ij5TdGFuZGFyZCBMYXlvdXQ8L3RleHQ+PHRleHQgeD0iNjAiIHk9IjE1MCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZm9udC1mYW1pbHk9IkFyaWFsIiBmb250LXNpemU9IjEyIiBmaWxsPSIjNkQ1QTQ3Ij5NZW7DvDwvdGV4dD48L3N2Zz4='
  },
  {
    id: 'wide',
    name: 'Breites Layout',
    description: 'Kategorien oben, Produkte in voller Breite',
    preview: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAwIiBoZWlnaHQ9IjMwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iNDAwIiBoZWlnaHQ9IjMwMCIgZmlsbD0iI0U4RTBENSIvPjxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjM4MCIgaGVpZ2h0PSI1MCIgZmlsbD0iI0I4OTk2OCIgb3BhY2l0eT0iMC4zIi8+PHJlY3QgeD0iMTAiIHk9IjcwIiB3aWR0aD0iMzgwIiBoZWlnaHQ9IjIyMCIgZmlsbD0iI0I4OTk2OCIgb3BhY2l0eT0iMC4yIi8+PHRleHQgeD0iMjAwIiB5PSIxODAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZvbnQtZmFtaWx5PSJBcmlhbCIgZm9udC1zaXplPSIxOCIgZmlsbD0iIzZENUE0NyI+QnJlaXRlcyBMYXlvdXQ8L3RleHQ+PHRleHQgeD0iMjAwIiB5PSI0MCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZm9udC1mYW1pbHk9IkFyaWFsIiBmb250LXNpemU9IjEyIiBmaWxsPSIjNkQ1QTQ3Ij5LYXRlZ29yaWVuPC90ZXh0Pjwvc3ZnPg=='
  },
  {
    id: 'grid',
    name: 'Grid Layout',
    description: 'Große Produktbilder im Raster',
    preview: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAwIiBoZWlnaHQ9IjMwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iNDAwIiBoZWlnaHQ9IjMwMCIgZmlsbD0iI0U4RTBENSIvPjxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjExNSIgaGVpZ2h0PSIxMzUiIGZpbGw9IiNBODhCNUUiIG9wYWNpdHk9IjAuMyIvPjxyZWN0IHg9IjE0MCIgeT0iMTAiIHdpZHRoPSIxMTUiIGhlaWdodD0iMTM1IiBmaWxsPSIjQTg4QjVFIiBvcGFjaXR5PSIwLjMiLz48cmVjdCB4PSIyNzAiIHk9IjEwIiB3aWR0aD0iMTE1IiBoZWlnaHQ9IjEzNSIgZmlsbD0iI0E4OEI1RSIgb3BhY2l0eT0iMC4zIi8+PHJlY3QgeD0iMTAiIHk9IjE1NSIgd2lkdGg9IjExNSIgaGVpZ2h0PSIxMzUiIGZpbGw9IiNBODhCNUUiIG9wYWNpdHk9IjAuMyIvPjxyZWN0IHg9IjE0MCIgeT0iMTU1IiB3aWR0aD0iMTE1IiBoZWlnaHQ9IjEzNSIgZmlsbD0iI0E4OEI1RSIgb3BhY2l0eT0iMC4zIi8+PHJlY3QgeD0iMjcwIiB5PSIxNTUiIHdpZHRoPSIxMTUiIGhlaWdodD0iMTM1IiBmaWxsPSIjQTg4QjVFIiBvcGFjaXR5PSIwLjMiLz48dGV4dCB4PSIyMDAiIHk9IjE1MCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZm9udC1mYW1pbHk9IkFyaWFsIiBmb250LXNpemU9IjE4IiBmaWxsPSIjNkQ1QTQ3Ij5HcmlkIExheW91dDwvdGV4dD48L3N2Zz4='
  },
  {
    id: 'minimal',
    name: 'Minimalistisch',
    description: 'Reduziertes Design, viel Weißraum',
    preview: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAwIiBoZWlnaHQ9IjMwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iNDAwIiBoZWlnaHQ9IjMwMCIgZmlsbD0iI0U4RTBENSIvPjxyZWN0IHg9IjUwIiB5PSI1MCIgd2lkdGg9IjMwMCIgaGVpZ2h0PSIyMDAiIGZpbGw9IiM2RDVBNDciIG9wYWNpdHk9IjAuMSIvPjxyZWN0IHg9IjcwIiB5PSI4MCIgd2lkdGg9IjI2MCIgaGVpZ2h0PSI0MCIgZmlsbD0iIzZENUE0NyIgb3BhY2l0eT0iMC4yIi8+PHJlY3QgeD0iNzAiIHk9IjE0MCIgd2lkdGg9IjI2MCIgaGVpZ2h0PSI0MCIgZmlsbD0iIzZENUE0NyIgb3BhY2l0eT0iMC4yIi8+PHRleHQgeD0iMjAwIiB5PSIxNTAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZvbnQtZmFtaWx5PSJBcmlhbCIgZm9udC1zaXplPSIxOCIgZmlsbD0iIzZENUE0NyI+TWluaW1hbCBMYXlvdXQ8L3RleHQ+PC9zdmc+'
  }
];

const LayoutsManager = ({ selectedLayout, onSave }) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Layout className="h-5 w-5" />
          Layout-Optionen für Seiten
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {pageLayouts.map((layout) => (
            <button
              key={layout.id}
              onClick={() => onSave(layout.id)}
              className={`group relative border-2 rounded-lg overflow-hidden transition-all hover:shadow-lg ${
                selectedLayout === layout.id ? 'border-green-500 ring-2 ring-green-500' : 'border-gray-300'
              }`}
            >
              {/* Preview Image */}
              <div className="aspect-video relative overflow-hidden bg-gray-100">
                <img
                  src={layout.preview}
                  alt={layout.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform"
                />
                {selectedLayout === layout.id && (
                  <div className="absolute top-2 right-2 bg-green-500 text-white p-1 rounded-full">
                    <Check className="h-4 w-4" />
                  </div>
                )}
              </div>
              
              {/* Layout Info */}
              <div className="p-4 bg-white">
                <h3 className="font-semibold text-gray-900 mb-1">{layout.name}</h3>
                <p className="text-xs text-gray-600">{layout.description}</p>
              </div>
            </button>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export default LayoutsManager;
